var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bsy-bottom"},[_c('div',{staticStyle:{"padding-top":"700px","margin-top":"30px"}},[_vm._v("知之信用管理（广东）有限公司 © 2022-2023")]),_c('el-link',{on:{"click":_vm.link}},[_vm._v("备案号：粤ICP备2022075214号-1")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }